import { CSSObject } from '@chakra-ui/react';

export const ModalHeader: CSSObject = {
  color: 'beta.300',
  fontWeight: 'bold',
  textTransform: 'uppercase',
  pb: '2',
  px: '4',
  bg: '#175e73',
};
export const ModalBody: CSSObject = {
  color: 'white',
  fontSize: 'sm',
  pb: '4',
  pt: '1',
  px: '4',
  bg: '#175e73',
};
export const ModalCloseButton: CSSObject = {
  pt: '1.5',
  pl: '1.5',
  color: 'white',
};
